/**
 * Depth — in the sideways chapters (street, factory) the far layers follow
 * the walk at a fraction of its pace: [data-depth] is that fraction (.3 far
 * away, 1 with the track, 1.5 in front of it).
 *
 * @module motion/depth
 */

import { REDUCED_MOTION } from '../config.js';
import { $, $$ } from '../lib/dom.js';
import { gsap } from '../lib/gsap.js';

export function animateDepth() {
    if (REDUCED_MOTION) {
        return;
    }

    $$('[data-strip]').forEach((section) => {
        const track = $('[data-strip-track]', section);
        const layers = $$('[data-depth]', section).map((element) => ({
            depth: Number.parseFloat(element.dataset.depth) || 0,
            setX: gsap.quickSetter(element, 'x', 'px'),
        }));

        if (!track || !layers.length) {
            return;
        }

        let last = null;

        gsap.ticker.add(() => {
            const x = Number(gsap.getProperty(track, 'x')) || 0;

            if (x === last) {
                return;
            }

            last = x;
            layers.forEach((layer) => layer.setX(x * layer.depth));
        });
    });
}
